// extracted by mini-css-extract-plugin
export default {"container":"ErrorComponent_container__rmeRL","title":"ErrorComponent_title__7NKa+","subtitle":"ErrorComponent_subtitle__JAFxF","message":"ErrorComponent_message__Io+qt"};